export function locationsTabs() {

    $('.locations .location-btn').each(function (idx) {
        var _id = $(this).data('name')

        document.querySelector('.location-btn[data-name="' + _id + '"]').addEventListener('keyup', function (event) {
            if (event.key === 'Enter') {// or keyCode === 13
                event.preventDefault();
                var _name = $(this).attr('data-name')
                var to = $('[data-location="' + _name + '"] .description').offset().top - $('.header').innerHeight()
                
                $('.locations li').removeClass('on')
                $('.locations li[data-name="' + _name + '"]').trigger('click')
                
                $(this).parent().removeClass('focus').addClass('on').attr('tabindex', '-1')

                $('section[data-location="' + _name + '"] address a').focus()
                history.pushState( null, null, location.origin + location.pathname + '?location=' + _name )
                $('html, body').animate({ scrollTop: to }, 800)
            }
            if (event.key === 'Tab') {// or keyCode === 9
                event.preventDefault()
                $('.locations li').removeClass('focus')
                $(this).parent().addClass('focus')
                $(this).focus()
            }
        })
    })

    $('.locations .location-btn').click(function (event) {
        event.preventDefault()
        const _body = $('body')
        var _name   = $(this).attr('data-name')

        $('.locations .location-btn').attr('tabindex', '0')
        $(this).attr('tabindex', '-1')
        $('.locations li').removeClass('on').removeClass('focus').attr('aria-expanded', 'false')
        $(this).parent().removeClass('focus').addClass('on')
        $('.wide-poster').hide().removeClass('active')
        $('section[data-location="' + _name + '"]').show().addClass('active')
        
        history.pushState( null, null, location.origin + location.pathname + '?location=' + _name )

        if ( _body.hasClass('page-template-page-our-menu-new') ) {
            var _name = $(this).attr('data-name')
            $(this).parent().addClass('on').attr('aria-expanded', 'true')
          
            $('.menu-listing .tab-menu').removeClass('active').attr('aria-selected', 'false')
            $('section[data-location="' + _name + '"] .tab-menu').attr('tabindex',0)

            $('.menu-tabs').attr({ 'hidden': true, 'tabindex': '-1', 'aria-hidden':true }).hide()
            $('#' + _name + '-1').attr({'hidden':false, 'tabindex':0, 'aria-hidden':false}).show()

            $('.tab-menu').attr('tabindex', '-1')            
            $('section[data-location="' + _name + '"] .tab-menu[data-slide="0"]').addClass('active').attr('aria-selected', 'true')
            
            $('.menu-section .menu-gallery').slick('slickGoTo', 0)
        }
    })

    document.addEventListener('DOMContentLoaded', function () {
        var _get_params = window.location.search.replace('?', '').split('&').reduce(function (p, e) {
                var a = e.split('=')
                p[decodeURIComponent(a[0])] = decodeURIComponent(a[1])
                return p
            }, {})

        if (typeof _get_params.location !== 'undefined') {
            var to = $('[data-location="' + _get_params.location + '"]').offset().top - $('.header').innerHeight()
            const chosen_tab = $('.locations a[data-name="' + _get_params.location + '"]')

            chosen_tab.trigger('click')

            $('.locations li').attr('aria-expanded', 'false')
            chosen_tab.parent().addClass('on').attr({ tabindex: '-1', 'aria-expanded': 'true' })

            $('html, body').animate({ scrollTop: to }, 800)
            $('section[data-location="' + _get_params.location + '"] address a').focus()
        }
    })

}


// WEBPACK FOOTER //
// ./assets/js/modules/locations-tabs.js